import { TFunction } from 'i18next'

import { BadgeColorKeys } from '@/components/ui/badge'
import {
  CommunicationStatus,
  CommunicationStatusEnum,
  CommunicationType,
  CommunicationTypeEnum,
} from '@/models'

export const getChannelName = (
  type: CommunicationType,
  t: TFunction<['communication']>,
): string => {
  const CHANNEL_LABEL_MAP: Record<CommunicationType, string> = {
    [CommunicationTypeEnum.enum.Email]: t('communication:announcements.list.channel.options.email'),
    [CommunicationTypeEnum.enum.Notification]: t(
      'communication:announcements.list.channel.options.notification',
    ),
    [CommunicationTypeEnum.enum.SMS]: t('communication:announcements.list.channel.options.sms'),
  }

  return CHANNEL_LABEL_MAP[type]
}

const STATUS_COLOR_MAP: Record<CommunicationStatus, BadgeColorKeys> = {
  [CommunicationStatusEnum.enum.Completed]: 'blue',
  [CommunicationStatusEnum.enum.Scheduled]: 'purple',
  [CommunicationStatusEnum.enum.Ongoing]: 'green',
  [CommunicationStatusEnum.enum.Processing]: 'orange',
}

export const getStatusColor = (status: CommunicationStatus): BadgeColorKeys =>
  STATUS_COLOR_MAP[status]
